import { render, staticRenderFns } from "./ListTeamsRating.vue?vue&type=template&id=7f8d54fd"
import script from "./ListTeamsRating.vue?vue&type=script&lang=js"
export * from "./ListTeamsRating.vue?vue&type=script&lang=js"
import style0 from "./ListTeamsRating.vue?vue&type=style&index=0&id=7f8d54fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports